import { Draggable } from "@hello-pangea/dnd";
import { Box } from "@mui/material";
import { ComponentType } from "react";

type WithDraggableProps<T> = T & {
  draggableId: string;
  index: number;
  isDragDisabled?: boolean;
};

const withDraggable = <T,>(Component: ComponentType<T>) => {
  // eslint-disable-next-line react/function-component-definition, react/display-name
  return (props: WithDraggableProps<Omit<T, "dragHandleProps">>) => {
    const { draggableId, index, isDragDisabled = false, ...rest } = props;

    return (
      <Draggable
        draggableId={draggableId}
        index={index}
        isDragDisabled={isDragDisabled}>
        {(provided) => (
          <Box
            ref={provided.innerRef}
            {...provided.draggableProps}
            style={provided.draggableProps.style}
            sx={{ ":not(:first-of-type)": { marginTop: 1 }, overflow: "unset" }}>
            <Component
              {...(rest as T)}
              dragHandleProps={provided.dragHandleProps}
            />
          </Box>
        )}
      </Draggable>
    );
  };
};

export default withDraggable;
